import { observer } from "mobx-react-lite";
import * as React from "react";
import { useEffect } from "react";
import { useStore } from "../root-store-context";
import { App, Button, Tabs } from "antd";
import CommunicationType from "./Content/CommunicationType";
import { UploadApp } from "./Content/Upload/UploadApp";
import { Recipients } from "./Content/Recipients/Recipients/Recipients";
import { Options } from "./Content/Options";
import { Send } from "./Content/Send";
import { RecipientsGeneral } from "./Content/Recipients/RecipientsGeneral/RecipientsGeneral";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";

export const StepByStepTab = observer(() => {
  const { stepByStepTabStore, applicationStore } = useStore();
  const { modal } = App.useApp();

  const getChildrenTab = (key: number): React.ReactNode => {
    switch (key) {
      case 1: return <CommunicationType />;
      case 2: return <UploadApp />;
      case 3:
        return applicationStore.mailJob.communicationTypeId === 1
          ? <RecipientsGeneral />
          : <Recipients />;
      case 4: return <Options />;
      case 5: return <Send />;
      default: return <CommunicationType />;
    }
  };

  const next = (): void => stepByStepTabStore.next();
  const prev = (): void => stepByStepTabStore.prev();

  const showModal = (): void => {
    const errorMsg = stepByStepTabStore.errorMessage;
    stepByStepTabStore.clearError();
    modal.warning({
      title: "Warning",
      content: errorMsg,
      okText: "Back",
      okButtonProps: { className: "cam__button-primary", size: "middle" },
    });
  };

  const renderTabLabel = (key: number, title: string): React.ReactNode => (
    <span className="cam__tab-label">
      <span className="cam__tab-number">{key}</span>
      <span className="cam__tab-title cam__tab-title--responsive">{title}</span>
    </span>
  );

  const renderTabContent = (key: number): React.ReactNode => (
    <div className="cam__tab-content-wrapper">
      <div className="cam__tab-content">{getChildrenTab(key)}</div>
      <div className="cam__footer-actions">
        <div className="cam__footer-left">
          {stepByStepTabStore.currentStep > 1 && (
            <Button
              data-testid="cam-previous-btn"
              className="cam__button-secondary"
              size="large"
              icon={<ArrowLeftOutlined />}
              onClick={prev}
            >
              Previous
            </Button>
          )}
        </div>
        <div className="cam__footer-right">
          {stepByStepTabStore.currentStep < 5 && (
            <Button
              data-testid="cam-next-btn"
              className="cam__button-primary"
              type="primary"
              size="large"
              onClick={next}
            >
              Next <ArrowRightOutlined />
            </Button>
          )}
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    if (stepByStepTabStore.isError) {
      showModal();
    }
  }, [stepByStepTabStore.isError]);

  return (
    <div className="cam__steps-card">
      <Tabs
        className="cam__tabs"
        activeKey={stepByStepTabStore.currentStep.toString()}
        size="large"
        indicator={{ size: 0 }}
        onChange={(tabKey: string) => {
          stepByStepTabStore.setTab(parseInt(tabKey, 10));
        }}
        items={stepByStepTabStore.stepList.map((step) => ({
          key: step.key.toString(),
          label: renderTabLabel(step.key, step.title),
          children: renderTabContent(step.key),
          disabled: !stepByStepTabStore.activeTabsList.includes(step.key),
        }))}
      />
    </div>
  );
});